import React, { Component } from 'react';
import Grid from '@mui/material/Grid';
import { IconButton, MenuItem, Select, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import DataArrayIcon from '@mui/icons-material/DataArray';
import HtmlIcon from '@mui/icons-material/Html';
import PinIcon from '@mui/icons-material/Pin';
import { CalendarIcon } from '@mui/x-date-pickers';
import { styled } from '@mui/material/styles';

const PlaceholderTypeText = styled('span')({
  fontSize: 14,
  paddingLeft: '8px',
  display: 'inline-flex',
  alignItems: 'center',
});

const PlaceholderSelect = styled(Select)({
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
  },
});

class PlaceholderItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableSaveButton: false,
      error: false,
      helperMessage: null,
    };
  }

  focus = () => {
    this.props.onFocus();
  };

  componentDidMount() {
    const placeholderItem = this.props.placeholder;
    if (placeholderItem) {
      this.setState({ placeholder: placeholderItem });
      this.setState({ index: this.props.index });
    }
  }

  validPlaceholderInput(value) {
    return /^[a-zA-Z]?$|^[a-zA-Z]([a-zA-Z0-9_]+)?$/.test(value) !== false;
  }

  render() {
    const { index, total, placeholder } = this.props;
    if (!placeholder) {
      return;
    }

    return (
      <Grid container rowSpacing={2} spacing={2} alignItems={'center'}>
        <Grid item xs={3}>
          <PlaceholderSelect
            fullWidth={true}
            variant="standard"
            value={placeholder.type ? placeholder.type : ''}
            defaultValue={'text'}
            onChange={event => {
              this.setState({ enableSaveButton: true });
              const placeholderType = {
                attribute: 'type',
                index: index,
                value: event.target.value,
              };
              this.props.onChange(placeholderType);
            }}
          >
            <MenuItem value={'text'}>
              <FormatSizeIcon fontSize="small" />
              <PlaceholderTypeText>Text</PlaceholderTypeText>
            </MenuItem>
            <MenuItem value={'number'}>
              <PinIcon fontSize="small" />
              <PlaceholderTypeText>Number</PlaceholderTypeText>
            </MenuItem>
            <MenuItem value={'list'}>
              <DataArrayIcon fontSize="small" />
              <PlaceholderTypeText>List</PlaceholderTypeText>
            </MenuItem>
            <MenuItem value={'html'}>
              <HtmlIcon fontSize="small" />
              <PlaceholderTypeText>HTML</PlaceholderTypeText>
            </MenuItem>
            <MenuItem value={'datetime'}>
              <CalendarIcon fontSize="small" />
              <PlaceholderTypeText>Date Time</PlaceholderTypeText>
            </MenuItem>
          </PlaceholderSelect>
        </Grid>
        <Grid item xs={8}>
          <TextField
            variant="outlined"
            placeholder="Type in a key from the return statement"
            fullWidth
            value={placeholder.key ? placeholder.key : ''}
            size="small"
            error={this.state.error}
            helperText={this.state.helperMessage}
            onChange={event => {
              const valueValidStatus = this.validPlaceholderInput(event.target.value);
              if (!valueValidStatus) {
                this.setState({ error: true });
                this.setState({
                  helperMessage:
                    'Accepts letters, numbers and underscores but must start with a letter',
                });
                return;
              }
              this.setState({ error: false });
              this.setState({ helperMessage: null });
              this.setState({ enableSaveButton: true });
              const placeholderKey = {
                attribute: 'key',
                index: index,
                value: event.target.value || '',
              };
              this.props.onChange(placeholderKey);
            }}
          />
        </Grid>
        <Grid item xs={1}>
          <div>
            <IconButton
              aria-label="delete"
              onClick={() => {
                this.props.onDelete(index);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default PlaceholderItem;
